<ms-numpad-host [id]="keypadId.toString()" />
